import { render } from "./Docs.vue?vue&type=template&id=da3e6726"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"

import "./Docs.vue?vue&type=style&index=0&id=da3e6726&lang=css"

import exportComponent from "/tmp/build_2d2f4584/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__